// import sOne from "../images/recommended/one.PNG";
// import sTwo from "../images/recommended/two.PNG";
// import sThree from "../images/recommended/three.PNG";
import parth from "../images/parth.png";
import vishw from "../images/vishw.jpg";
import lili from "../images/lili.jpg";

export const stories = [
  {
    id: 1,
    name: "Story One",
    image: parth,
  },
  {
    id: 2,
    name: "Story Two",
    image: vishw,
  },
  {
    id: 3,
    name: "Story Three",
    image: lili,
  },
];
